<template>
    <v-card class="mx-auto" shaped elevation="7" min-height="700px">
        <v-card-title>
            Notificar Siniestro de Vehículo
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-md>
                <v-stepper v-model="ii" vertical class="removeBorder">

                    <v-stepper-step :complete="ii > 1" step="1"> Escoger Seguro </v-stepper-step>
                    <v-stepper-content step="1">
                        <v-row dense align="center" justify="center">
                            <v-col cols="12" sm="4" v-for="(v,k) in _.get(listGeneral,'listCertificado',[])" :key="k">
                                <v-tooltip bottom color="primary">
                                    <template v-slot:activator="{ on }">
                                        <v-img :src="v.foto" contain height="300px" max-height="300px" v-on="on"></v-img>
                                    </template>
                                    <span>
                                        <table width="100%">
                                            <tbody>
                                                <tr>
                                                    <td> <strong class="white--text body-2">Marca: </strong> </td>
                                                    <td class="body-2" v-html="v.marca"> </td>
                                                </tr>
                                                <tr>
                                                    <td> <strong class="white--text body-2">Modelo: </strong> </td>
                                                    <td class="body-2" v-html="v.modelo"> </td>
                                                </tr>
                                                <tr>
                                                    <td> <strong class="white--text body-2">Año: </strong> </td>
                                                    <td class="body-2" v-html="v.anio"> </td>
                                                </tr>
                                                <tr>
                                                    <td> <strong class="white--text body-2">Cédula: </strong> </td>
                                                    <td class="body-2" v-html="v.numeroDocumento"> </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </span>
                                </v-tooltip>
                                <div class="text-center">
                                    <h3 class="headline">Placa: {{ v.placa }}</h3>
                                </div>
                                <v-btn block rounded dark color="primary" @click="next(v)">Notificar Siniestro</v-btn>
                            </v-col>
                        </v-row>
                    </v-stepper-content>

                    <v-stepper-step :complete="ii > 2" step="2"> Información de Siniestro </v-stepper-step>
                    <v-stepper-content step="2">
                        <v-form ref="form_siniestro">
                            <v-row dense>
                                <v-col cols="12" sm="6">
                                    <v-dialog ref="dialog" v-model="obDate.open" :return-value.sync="obSiniestro.fechaOcurrencia"
                                        persistent width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field color="textbox" v-model="obSiniestro.fechaOcurrencia"
                                                :label="getPregunta(1)" :rules="requeridoRegla" prepend-inner-icon="event" readonly
                                                outlined dense v-on="on" />
                                        </template>
                                        <v-date-picker color="primary" v-model="obSiniestro.fechaOcurrencia" scrollable locale="es">
                                            <v-spacer></v-spacer>
                                            <v-btn outlined dense rounded color="danger" @click="obDate.open = false"
                                                v-html="'Salir'"></v-btn>
                                            <v-btn rounded dark color="primary"
                                                @click="$refs.dialog.save(obSiniestro.fechaOcurrencia)" v-html="'Guardar Fecha'">
                                            </v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-autocomplete :label="getPregunta(2)" color="textbox" v-model="obSiniestro.idTipoSiniestro"
                                        :items="listGeneral.listTipoSiniestro" item-text="tipoSiniestro"
                                        item-value="idSecTipoSiniestro" :rules="requeridoRegla" outlined dense />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="6">
                                    <v-autocomplete :label="getPregunta(3)" color="textbox" v-model="obSiniestro.idPregunta3"
                                        :items="listGeneral.listDesicion" :rules="requeridoRegla" outlined dense />
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-autocomplete :label="getPregunta(4)" color="textbox" v-model="obSiniestro.idPregunta4"
                                        :items="listGeneral.listDesicion" :rules="requeridoRegla" outlined dense />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12">
                                    <v-textarea :label="getPregunta(5)" color="textbox" no-resize v-model="obSiniestro.idPregunta5"
                                        :value="obSiniestro.idPregunta1" :rules="requeridoRegla" counter="1000" outlined dense />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col class="text-right mt-3 mb-3">
                                    <v-btn outlined rounded color="danger" @click="--ii" class="mr-1" :disabled="disabled">Anterior</v-btn>
                                    <v-btn rounded dark color="primary" @click="insertarActualizar" v-html="'Guardar'" :disabled="disabled"></v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-stepper-content>
                </v-stepper>

            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        data:() => ({
            obDate:{ open: false },
            disabled: false,
            listGeneral: {},
            ii:1,
            idCliente:null,
            obSiniestro: {
                idProducto: null,
                idSeguro: null,
                idCertificado: null,
                idPoliza: null,
                idPregunta3:null,
                idPregunta4:null,
                idPregunta5:null,
                fechaOcurrencia: moment().format('YYYY-MM-DD'),
                fechaReportado:  moment().format('YYYY-MM-DD'),
                idTipoSiniestro: null,
                idEstado: null
            }
        }),
        created(){
            var error = 'E';

            axios.post(`${BASE_URI}administrador/siniestro/cargaGeneralVehiculo`,{})
                 .then((r)=>{
                     if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                     if(_.size(_.get(r,['data','data'],[])) == 0){ error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                        this.$set(this,'listGeneral',r.data.data);
                        this.listGeneral.listDesicion = _.map(this.listGeneral.listDesicion,(v,k) => { return {'text':v,'value':k}; });
                        this.obSiniestro.idEstado = this.listGeneral.listParametro.idEstadoDefault;
                        this.idCliente = _.get(this.$root.obUsuario,'idCliente',null);
                        return this.onListarCertificado('L');
                 })
                 .catch((e)=>{
                     mensajesAlerta(e,'E');
                 });
        },
        methods:{
            next(objeto){
                this.obSiniestro = _.merge({},this.obSiniestro,objeto);
                ++this.ii;
            },
            getPregunta(index){
                var ob = _.find(this.listGeneral.listPregunta,(v)=>{ return parseInt(v.idPregunta) == index; });
                return _.get(ob,'pregunta','Error')+' *';
            },
            onListarCertificado(event){
                if(!_.isUndefined(event)){
                    var objeto = {
                        opcion    :  'LISTAR_CERTIFICADO_VEHICULO',
                        loadFile  :  true,
                        idCliente :  this.idCliente
                    };

                    var error = 'E';

                    this.listGeneral.listCertificado = [];
                    axios.post(`${BASE_URI}administrador/notificacion/listar`,objeto)
                         .then((r) => {
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0){ error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                this.listGeneral.listCertificado = r.data.data;
                         })
                         .catch((e) =>{
                             mensajesAlerta(e,error);
                         });
                }
            },
            insertarActualizar(){
                try {
                    this.disabled = true;
                    if(!this.$refs.form_siniestro.validate()) throw mensajeEstandar.corregirInformacion;
                    if((moment(this.obSiniestro.fechaOcurrencia).format('YYYY-MM-DD')) > (moment().format('YYYY-MM-DD'))) throw 'La fecha de ocurrencia no puede ser mayor a la fecha actual.';

                    var objeto = {
                        // "opcion": "IN",
                        "obSiniestro": _.merge(                                            
                                                {},_.pick(this.obSiniestro,['idCertificado','fechaOcurrencia','fechaReportado','idTipoSiniestro','idEstado']),
                                                {idPoliza: (_.find(this.listGeneral.listCertificado,{idCertificado:this.obSiniestro.idCertificado})).idPoliza}
                                            ),
                        "listPreguntaNotificacion": this.getStructListPregunta()
                    }    
                    
                    axios.post(`${BASE_URI}administrador/siniestro/insertOrUpdate/notificacion`,objeto)
                        .then((response) => {
                            if(_.size(_.get(response,['data','data'],0)) == 0) throw _.get(response,['data','mensaje'],'Ocurrio un error al leer la información.');
                                mensajeAlertaTiempo('Se realizo su notificación con exito.','S');
                                this.obSiniestro= {
                                                    idPregunta3:null,
                                                    idPregunta4:null,
                                                    idPregunta5:null,
                                                    fechaOcurrencia: moment().format('YYYY-MM-DD'),
                                                    fechaReportado:  moment().format('YYYY-MM-DD'),
                                                    idTipoSiniestro: null,
                                                    idEstado: this.listGeneral.listParametro.idEstadoDefault
                                                }

                                this.$refs.form_siniestro.resetValidation();
                                setTimeout(() => {
                                    this.disabled = false;
                                    window.location.reload();
                                }, 700);
                        })
                        .catch((e) =>{
                            mensajesAlerta(e,'E');
                            this.disabled = false;
                        });

                } catch (error) {
                    mensajesAlerta(error,'I');
                    this.disabled = false;
                }
            },
            getStructListPregunta(){
                var l = [];
                _.forEach(this.listGeneral.listPregunta,(v) => {
                    if(!_.isNull(_.get(this.obSiniestro,`idPregunta${v.idPregunta}`,null)) && !_.isUndefined(_.get(this.obSiniestro,`idPregunta${v.idPregunta}`)))
                        l.push({  idPregunta: v.idPregunta, respuesta: _.get(this.obSiniestro,`idPregunta${v.idPregunta}`,null) });
                });

                return l;
            }
        }
    }
</script>
<style>
    .removeBorder {
        box-shadow: none;
    } 
</style>